<template>
    <div>
        <b-row class="pb-2">
            <b-col>
                <app-detalhe titulo="Número do Contrato" :xl="xl">
                    <strong>{{ contrato.vcCodigoEstruturado }}</strong>
                </app-detalhe>

                <app-detalhe titulo="Contrato RM" :xl="xl">
                    <app-status
                        :status="contrato.vinculoRM ? 'OK' : 'NOK'"
                        class="mr-2"
                        v-if="contrato.vinculoRM"
                    ></app-status>
                    <app-status
                        :status="contrato.contratoRM"
                        v-if="contrato.contratoRM"
                    ></app-status>
                </app-detalhe>

                <app-detalhe titulo="Fornecedor" :xl="xl">
                    <strong>
                        {{
                            contrato.fornecedor ? contrato.fornecedor.nome : ''
                        }}
                        <span
                            v-if="
                                contrato.fornecedor && contrato.fornecedor.cnpj
                            "
                        >
                            | {{ contrato.fornecedor.cnpj }}</span
                        >
                        <span
                            v-if="
                                contrato.fornecedor && contrato.fornecedor.email
                            "
                        >
                            | {{ contrato.fornecedor.email }}</span
                        >
                        <span
                            v-if="
                                contrato.fornecedor &&
                                contrato.fornecedor.telefone
                            "
                        >
                            | {{ contrato.fornecedor.telefone }}</span
                        >
                    </strong>
                </app-detalhe>

                <app-detalhe titulo="Valor Global do Contrato" :xl="xl">
                    <strong>
                        {{ contrato.nuValorGlobalContrato | currency }}
                    </strong>
                </app-detalhe>

                <app-detalhe titulo="Saldo do Contrato" :xl="xl">
                    <strong>{{ contrato.nuSaldoContrato | currency }}</strong>
                </app-detalhe>

                <app-detalhe titulo="Situação" :xl="xl">
                    <app-status
                        :status="contrato.situacaoContrato.toUpperCase()"
                        v-if="contrato.situacaoContrato"
                    ></app-status>
                </app-detalhe>

                <app-detalhe titulo="Tipo do Contrato" :xl="xl">
                    <strong>
                        {{
                            contrato.tipoContrato
                                ? contrato.tipoContrato.toUpperCase()
                                : ''
                        }}
                    </strong>
                </app-detalhe>

                <app-detalhe titulo="Processo" :xl="xl">
                    <strong>{{ contrato.processo }}</strong>
                </app-detalhe>

                <app-detalhe titulo="Natureza de Despesa" :xl="xl">
                    <strong>
                        {{ contrato.codigoNatureza }} -
                        {{
                            contrato.natureza
                                ? contrato.natureza.toUpperCase()
                                : ''
                        }}
                    </strong>
                </app-detalhe>

                <app-detalhe titulo="Gestor" :xl="xl">
                    <strong>{{ contrato.solicitante }}</strong>
                </app-detalhe>

                <app-detalhe titulo="Gerente" :xl="xl">
                    <strong>{{ contrato.nomeGerente }}</strong>
                </app-detalhe>

                <app-detalhe titulo="Unidade" :xl="xl">
                    <strong>
                        {{
                            contrato.unidade
                                ? contrato.unidade.toUpperCase()
                                : ''
                        }}
                    </strong>
                </app-detalhe>

                <app-detalhe titulo="Objeto" :xl="xl">
                    <strong>{{ contrato.vcObjetoContrato }}</strong>
                </app-detalhe>
            </b-col>
            <b-col>
                <app-detalhe titulo="Categoria" :xl="xl">
                    <strong>{{ contrato.categoria }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Tipo da Contratação" :xl="xl">
                    <strong>{{ contrato.tipoContratacao }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Tipo da Licitação" :xl="xl">
                    <strong
                        >{{ contrato.tipoLicitacao }}
                        <span v-if="contrato.numeroLicitacao"
                            >({{ contrato.numeroLicitacao }})</span
                        ></strong
                    >
                </app-detalhe>
                <app-detalhe titulo="Vigência" :xl="xl">
                    <strong>
                        {{
                            contrato.dtInicioVigencia
                                ? $moment(contrato.dtInicioVigencia).format(
                                      'DD/MM/YYYY'
                                  )
                                : ''
                        }}
                        a
                        {{
                            contrato.dtFimVigencia
                                ? $moment(contrato.dtFimVigencia).format(
                                      'DD/MM/YYYY'
                                  )
                                : ''
                        }}
                    </strong>
                </app-detalhe>

                <app-detalhe titulo="Prazo de Execução" :xl="xl">
                    <strong>
                        {{
                            contrato.dtInicioPrazoExecucao
                                ? $moment(
                                      contrato.dtInicioPrazoExecucao
                                  ).format('DD/MM/YYYY')
                                : ''
                        }}
                        a
                        {{
                            contrato.dtFimPrazoExecucao
                                ? $moment(contrato.dtFimPrazoExecucao).format(
                                      'DD/MM/YYYY'
                                  )
                                : ''
                        }}
                    </strong>
                </app-detalhe>
                <app-detalhe titulo="Garantia Contratual" :xl="xl">
                    <strong>
                        {{
                            contrato.flGarantiaContratual === 1 ? 'SIM' : 'NÃO'
                        }}
                    </strong>
                </app-detalhe>

                <app-detalhe
                    titulo="% Garantia"
                    :xl="xl"
                    v-if="contrato.flGarantiaContratual === 1"
                >
                    <strong>{{ contrato.nuPercentGarantia }}</strong>
                </app-detalhe>
                <app-detalhe
                    titulo="Total da Garantia"
                    :xl="xl"
                    v-if="contrato.flGarantiaContratual === 1"
                >
                    <strong>
                        {{
                            ((contrato.nuPercentGarantia *
                                contrato.nuValorGlobalContrato) /
                                100)
                                | currency
                        }}
                    </strong>
                </app-detalhe>
                <app-detalhe
                    titulo="Data Final da Garantia"
                    :xl="xl"
                    v-if="contrato.flGarantiaContratual === 1"
                >
                    <strong>
                        {{
                            contrato.dataFinalGarantia
                                ? $moment(contrato.dataFinalGarantia).format(
                                      'DD/MM/YYYY'
                                  )
                                : ''
                        }}
                    </strong>
                </app-detalhe>
                <app-detalhe
                    titulo="Tipo da Garantia"
                    :xl="xl"
                    v-if="contrato.flGarantiaContratual === 1"
                >
                    <strong>{{ contrato.tipoGarantia }}</strong>
                </app-detalhe>
                <app-detalhe
                    titulo="Garantia Apresentada"
                    :xl="xl"
                    v-if="contrato.flGarantiaContratual === 1"
                >
                    <app-status
                        :status="contrato.garantiaApresentada ? 'SIM' : 'NÃO'"
                    ></app-status>
                </app-detalhe>
                <app-detalhe
                    titulo="Observações da Garantia"
                    :xl="xl"
                    v-if="contrato.flGarantiaContratual === 1"
                >
                    <strong>{{ contrato.obsGarantia }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Envio para o Fornecedor" :xl="xl">
                    <strong>
                        {{
                            contrato.dtEnvioFornecedor
                                ? $moment(contrato.dtEnvioFornecedor).format(
                                      'DD/MM/YYYY'
                                  )
                                : ''
                        }}
                    </strong>
                </app-detalhe>
                <app-detalhe titulo="Retorno do Fornecedor" :xl="xl">
                    <strong>
                        {{
                            contrato.dtRetornoFornecedor
                                ? $moment(contrato.dtRetornoFornecedor).format(
                                      'DD/MM/YYYY'
                                  )
                                : ''
                        }}
                    </strong>
                </app-detalhe>
                <app-detalhe titulo="Envio para a Diretoria" :xl="xl">
                    <strong>
                        {{
                            contrato.dtEnvioDiretoria
                                ? $moment(contrato.dtEnvioDiretoria).format(
                                      'DD/MM/YYYY'
                                  )
                                : ''
                        }}
                    </strong>
                </app-detalhe>
                <app-detalhe titulo="Retorno da Diretoria" :xl="xl">
                    <strong>
                        {{
                            contrato.dtRetornoDiretoria
                                ? $moment(contrato.dtRetornoDiretoria).format(
                                      'DD/MM/YYYY'
                                  )
                                : ''
                        }}
                    </strong>
                </app-detalhe>
                <app-detalhe
                    titulo="Início do Aditivo"
                    :xl="xl"
                    v-if="contrato.dtInicioVigenciaAditivo"
                >
                    <strong>
                        {{
                            contrato.dtInicioVigenciaAditivo
                                ? $moment(
                                      contrato.dtInicioVigenciaAditivo
                                  ).format('DD/MM/YYYY')
                                : ''
                        }}
                    </strong>
                </app-detalhe>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            xl: 3
        }
    }
}
</script>
